// extracted by mini-css-extract-plugin
export default {"Container":"MiddleModelVideo_Container__hki2W","UploadBox_right":"MiddleModelVideo_UploadBox_right__H0lyC","UploadBox_right_":"MiddleModelVideo_UploadBox_right___0wewZ"};